import keys from '@debbie/common/dist/cache/keys.js';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { CountryCode, Entity, Site } from '@debbie/common/dist/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import * as casesLib from '@debbie/cortex/dist/api/cases.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { casesEntity, ensureCaseLoaded, useCase, } from '@debbie/cortex/dist/cases/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { useUltimateCreditor } from '@debbie/cortex/dist/ultimate-creditors/index.js';
import { useUpdatesByRefId } from '@debbie/cortex/dist/updates/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { APIBASE } from '../../config.js';
import THEME from '../../theme.js';
import { CopyToClipboard, EditReferenceId, PlaceholderLoader, } from '..//index.js';
import CustomerPreview from '../Customers/CustomerPreview.js';
import DebtRegistrationReporting from '../DebtRegistration/index.js';
import { Col, Row } from '../Grid/index.js';
import CasePrediction from '../wincent/CasePrediction.js';
import CasePaymentPlan from './CasePaymentPlan.js';
import CaseSatisfactions from './CaseSatisfactions.js';
import FromCase from './FromCase.js';
import FsNumbers from './FsNumbers.js';
import Header from './Header.js';
import ImportantUpdates from './ImportantUpdates.js';
const CaseInfo = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const tenant = useTenant();
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const paymentPlansLoadable = usePaymentPlansByCaseId(singleCase?.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const ultimateCreditorLoadable = useUltimateCreditor(singleCase?.ultimateCreditorId);
    const ultimateCreditor = singleCase?.ultimateCreditorId != null &&
        h.hasData(ultimateCreditorLoadable)
        ? ultimateCreditorLoadable.data
        : null;
    const updatesLoadable = useUpdatesByRefId(singleCase?.caseId);
    const updates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const interactionsLoadable = useInteractionsByReference(Entity.Case, singleCase?.caseId, true);
    const interactions = h.hasData(interactionsLoadable)
        ? interactionsLoadable.data
        : null;
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const collectorLoadable = useCollector((singleCase &&
        creditor &&
        getCollectorOnCase(singleCase.type, singleCase.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const updateMigratedId = async (id) => {
        singleCase &&
            (await casesLib.patch(singleCase.caseId, {
                migratedId: id,
            }));
        q.invalidate(keys.write.modify(casesEntity, props.caseId));
        await ensureCaseLoaded(props.caseId);
    };
    return (React.createElement("div", null,
        React.createElement(CaseInfoStyled, null, !singleCase ? (React.createElement("div", null,
            React.createElement(Col, { width: "8" },
                React.createElement(PlaceholderLoader, null),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "50%" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "65%" })),
            React.createElement(Col, { width: "4" },
                React.createElement(PlaceholderLoader, null)))) : (React.createElement(React.Fragment, null,
            React.createElement(Header, { caseId: props.caseId }),
            React.createElement(Col, { width: "8" },
                React.createElement(FsNumbers, { caseId: singleCase.caseId }),
                singleCase && singleCase.migratedId ? (React.createElement("p", { style: { fontSize: '0.8em' } },
                    React.createElement("small", null, "Migreret journalnummer"),
                    React.createElement("div", { style: {
                            fontFamily: "'Courier New', Courier, monospace !important",
                            fontWeight: 'bold',
                        } },
                        React.createElement(CopyToClipboard, { text: singleCase.migratedId }, singleCase.migratedId)),
                    React.createElement("br", null))) : ((singleCase.tenantId ===
                    '92b91d97-ebda-4fd3-8d48-71247af5ec8a' || //Oxilio tenantId
                    (me && exclusiveContent?.includes(me.id))) &&
                    site === Site.Caseworker && (React.createElement("span", { "data-tooltip-content": 'Tilføj migreret journalnummer', "data-tooltip-id": "tooltip-default" },
                    React.createElement(EditReferenceId, { value: singleCase.migratedId, onUpdate: updateMigratedId, placeholder: 'Migreret journalnummer', style: { marginTop: '0.5em' } })))),
                singleCase?.customerId && (React.createElement("div", { style: { marginTop: '20px' } },
                    React.createElement(CustomerPreview, { customerId: singleCase.customerId, onClickOnUser: (user) => c.redirect.redirect(`/creditors/${singleCase.creditorId}/customers/${singleCase.customerId}/users/${user.userId}?backToCaseId=${singleCase.id}&backToCasePath=${encodeURIComponent(window.location.pathname)}`), caseId: singleCase.caseId }))),
                React.createElement(CaseSatisfactions, { caseId: props.caseId }),
                React.createElement(FromCase, { caseId: props.caseId }),
                caseVouchers &&
                    singleCase &&
                    creditor &&
                    customer &&
                    documents &&
                    interactions &&
                    updates &&
                    paymentPlans && (React.createElement("div", { style: { marginTop: '16px' } },
                    React.createElement(CasePrediction, { caseVouchers: caseVouchers, case: singleCase, customer: customer, documents: documents, interactions: interactions, updates: updates, paymentPlans: paymentPlans })))),
            React.createElement(Col, { width: "4" },
                site === Site.Caseworker &&
                    tenant?.type === TenantType.Agency && (React.createElement("div", null,
                    React.createElement("div", { className: "case-info-title" }, lang.creditors.creditor),
                    React.createElement(Link, { style: {
                            color: 'initial',
                            textDecoration: 'none',
                        }, to: `/creditors/${singleCase.creditorId}` },
                        React.createElement("div", { className: "case-info-content" },
                            creditor && creditor.name,
                            ' ',
                            creditor && creditor.id && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement("small", { onClick: (e) => {
                                        e.preventDefault();
                                    } },
                                    React.createElement(CopyToClipboard, { text: creditor.id }, creditor && creditor.id)))))))),
                site === Site.Caseworker && ultimateCreditor && (React.createElement("div", null,
                    React.createElement("div", { className: "case-info-title" }, lang.ultimateCreditors.ultimateCreditor),
                    React.createElement("div", { className: "case-info-content" },
                        ultimateCreditor.name,
                        React.createElement("br", null),
                        React.createElement("small", null,
                            React.createElement(CopyToClipboard, { text: ultimateCreditor.referenceId }, ultimateCreditor.referenceId))))),
                React.createElement("div", null,
                    React.createElement("div", { className: "case-info-title" }, lang.collectors.collector),
                    React.createElement("div", { className: "case-info-content" }, collector &&
                        (collector.logo ? (React.createElement(Collector, null,
                            React.createElement("img", { alt: collector.logo.fileName || undefined, src: `${APIBASE}/files/${collector.logo.fileId}/${collector.logo.fileName}` }))) : (React.createElement("span", null, collector.name))))),
                React.createElement(ImportantUpdates, { caseId: singleCase.caseId }),
                React.createElement("div", null,
                    React.createElement(CasePaymentPlan, { caseId: singleCase.caseId }),
                    singleCase &&
                        customer &&
                        caseVouchers &&
                        (tenant?.aksSettings?.enabled ||
                            tenant?.debitorRegistretSettings?.enabled) &&
                        tenant.countryCode === CountryCode.DK && (React.createElement(DebtRegistrationReporting, { case: singleCase, customer: customer, caseVouchers: caseVouchers })))))))));
};
export default CaseInfo;
const Collector = styled.div `
  img {
    max-height: 100%;
    max-width: 70%;
    display: block;
  }
`;
const CaseInfoStyled = styled(Row) `
  h3 {
    margin: 0;
    small {
      font-size: 0.7em;
      font-weight: normal;
    }
    & > span.border-left {
      border-left: 1px solid ${THEME.BORDER_STRONG};
      font-size: 0.55em;
      font-weight: normal;
      margin-left: 14px;
      padding-left: 10px;
      svg {
        margin: 5px 0 -1px 0;
      }
    }
  }
  & > div {
  }
  .case-info-title {
    color: ${THEME.TEXT_SUBTLE};
    font-size: 0.9em;
    font-weight: 900;
    margin-top: 1.3em;
    word-wrap: break-word;
  }
  .case-info-content {
    font-size: 1em;
    margin: 0.7em 0 1em 0;
    word-wrap: break-word;
  }
`;
//# sourceMappingURL=CaseInfo.js.map